import React, { useState, useEffect } from "react";
import TodosHoc from "components/todos/hoc/TodosHoc";
import SideList from "./SideList";

const TodoSidebarList = props => {
  const {
    todoState: { },
    todoDispatcher
  } = props;

  const activeListHandler = (id, title, createdAt) => {
    todoDispatcher({
      type: "setActiveSidelist",
      data: {
        id: id,
        title: title,
        created: createdAt
      }
    });
  };

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    fetch('/service/notifications/show')
    .then(res => res.json())
    .then((data) => {
      setNotifications(data.notifications)
      return props.todoState.todos = data.messages
    })


    

  }, [])

  return (
    <div className="todo-sidebar-list roe-box-shadow pa-10 fill-height todo-sidebar-container">
      {
        (notifications && notifications.length) &&
        notifications.map((not, index) => {
          return (
            <SideList
            key={index}
            icon="wb_sunny"
            title={not.name}
            count={not.length}
            activeListHandler={() => activeListHandler(not._id, not.name, not.createdAt)}
          />
          )
        })
      }
      {
        /*
        <SideList
        icon="wb_sunny"
        title="My day"
        count={mydayTodoCount}
        activeListHandler={() => activeListHandler(null, "My Day")}
      />
      <SideList
        icon="star_border"
        title="Important"
        count={importantTodoCount}
        activeListHandler={() => activeListHandler(null, "Important")}
      />
      <SideList
        icon="bookmarks"
        title="Bookmarked"
        count={bookmarkTodoCount}
        activeListHandler={() => activeListHandler(null, "Bookmarked")}
      />
        */
      }
      
    </div>
  );
};

export default TodosHoc(TodoSidebarList);
